
<template>
  <div>
    <NavBar />
    <div id="main">
      <q-layout view="hHh LpR fFf">
        <q-page-container>
          <div id="wrapper" class="full-width full-height">
            <q-page>
              <router-view />
            </q-page>
          </div>
        </q-page-container>
      </q-layout>
    </div>
  </div>
</template>
<script>
import { QLayout, QPageContainer, QPage } from 'quasar';
import NavBar from '@/components/navbar/Navbar.vue';

export default {
  components: {
    QLayout,
    QPageContainer,
    QPage,
    NavBar
  }
};
</script>
<style lang="scss">
#wrapper {
  padding: 0 79px 20px 79px;
}

#main {
  .selected-item-single-item-active {
    background-color: $seafoam-blue;
  }
  .item-container-selected {
    color: $seafoam-blue;
  }

  .dinapsis-user-menu {
    z-index: 99;

    .dx-scrollview-content {
      .dx-item-content.dx-list-item-content {
        .dx-list-item-icon-container {
          .dx-list-item-icon {
            height: auto;
          }
        }
      }
    }
  }

  .dx-drawer-panel-content {
    width: 256px !important;
    .navbar-sidebar {
      width: 256px;
      .accordion-menu-item-list {
        width: 256px;
        .menu-item {
          width: 100%;
        }
      }
    }
  }
}
</style>
